import React from 'react';

import { DossierDtoAdminFonctionnelSuiviDestructionSivEnum } from 'lib_api/lib/api/gen';

import { useDossierAdminContext } from 'hooks/dossierAdmin/DossierAdminContext';
import { LABEL_DONNEE_EXPIREE, LABEL_SANS_PLAQUE } from 'utils/global';

import { StatusContent } from './StatutContent/StatusContent';

import './MainInfoHeader.less';

export const MainInfoHeader = (): React.ReactElement => {
  const [{ result: dossier }] = useDossierAdminContext();

  const isDetruitSiv =
    dossier.suiviDestructionSiv ===
    DossierDtoAdminFonctionnelSuiviDestructionSivEnum.DETRUIT_APRES_SORTIE;

  return (
    <div className="MainInfoHeader">
      {dossier.immatriculation ? (
        <span className="Immatriculation">{dossier.immatriculation}</span>
      ) : (
        <span className="Immatriculation SansPlaque">
          {dossier.anonymise ? LABEL_DONNEE_EXPIREE : LABEL_SANS_PLAQUE}
        </span>
      )}

      <span>
        <StatusContent status={dossier.status} />
      </span>
      <span className="TextBox Branche">{dossier.currentBranche}</span>

      {isDetruitSiv && <span className="TextBox DetruitSiv">Détruit SIV</span>}
      {dossier.interdictionCirculer && (
        <span className="TextBox InterdictionCirculer">
          Interdiction de circuler
        </span>
      )}
      {dossier.volConfirme && <span className="TextBox vol">Vol</span>}
    </div>
  );
};
